import React from 'react'
import {graphql} from 'gatsby'
import BlockContent from '../components/block-content'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import SEO from '../components/seo'
import Layout from '../containers/layout'
import ContributorList from '../components/Contributor/contributor-list'

export const query = graphql`
  query ContributorsPageQuery {
    page: sanityPage(_id: {regex: "/(drafts.|)contributorsPage/"}) {
      title
      _rawContent
    }
    contributors: allSanityPerson(
      sort: {order: ASC, fields: name}
    ) {
      nodes {
        _id
        name
        roles
        title
        _rawImage
        slug {
          current
        }
      }
    }
  }
`

const ContributorsPage = props => {
  const {data, errors} = props

  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }

  const page = (data || {}).page
  const contributors = data && data.contributors && data.contributors.nodes

  return (
    <Layout>
      <SEO title={page.title} description={page.description} keywords={page.keywords} />
      <Container>
        <div>
          <BlockContent blocks={page._rawContent} />
        </div>
        {contributors && (
          <div>
            <ContributorList contributors={contributors} />
          </div>
        )}
      </Container>
    </Layout>
  )
}

export default ContributorsPage
